import { DefaultTheme } from 'styled-components';

export const defaultTheme: DefaultTheme = {
  colors: {
    black: '#101D40',
    softBlack: '#25396F',
    lightGrey: '#E6EFFB',
    white: '#FFFFFF',
    orange: '#FF8946',
    pink: '#FF2190',
    grey: '#7C8DB5',
    red: '#F64444',
    green: '#35BA83',
    main: '#329BFC',
    scrollbar: '#CCCCCC',
  },
  breakpoints: {
    xxxl: 1550,
    xxl: 1440,
    xl: 1200,
    lg: 992,
    md: 768,
    sm: 576,
  },
};
